
import React from 'react'
import Map from '../../../../../../common/components/map'
import _ from 'lodash';

export default function OrderAddressComponent({ jobDetails, selectedOrder }: any) {
    const originGps = selectedOrder?.fulfillments?.[0]?.start?.location?.gps;
    const destinationGps = selectedOrder?.fulfillments?.[0]?.end?.location?.gps;
    const image = require('../../../../../../assets/img/delivery.png')
    const latLongData: any = _.split(originGps, ',');
    const startInfo = selectedOrder?.fulfillments?.[0]?.start
    const endInfo = selectedOrder?.fulfillments?.[0]?.end

    return (
        <>

            <div className="flex flex-col items-center bg-white w-full px-5 overflow-auto h-auto pt-10 pb-10">


                {originGps && <div className="w-full px-5 text-gray-800">

                    <div className="w-full">
                        <Map
                            lat={latLongData[0]}
                            lng={latLongData[1]}
                            height={'420px'}
                            zoom={15}
                            icon={image}
                            showInfoWindow={false}
                            isRouteDirection={true}
                            originLocation={originGps}
                            destinationLocation={destinationGps}
                        />

                    </div>
                </div>}

                <div className="w-full min-h-full flex justify-between flex-col md:flex-row">

                    <div className="px-5 w-full mt-10">
                        <div className="mb-2">
                            <h3 className="font-bold text-gray-600 text-xl">Pickup</h3>
                        </div>
                        {startInfo && <div className="mb-2 text-gray-400">
                            <div><span className="text-gray-500 text-sm">Code:</span><span className="text-gray-600 text-sm px-2">{selectedOrder?.PickupCode}</span></div>
                            <div><span className="text-gray-500 text-sm">Name</span><span className="text-gray-600 text-sm px-2">{startInfo?.location?.address?.name}</span></div>
                            <div><span className="text-gray-500 text-sm break-words">Address:</span><span className="text-gray-600 text-sm px-2">{startInfo?.location?.address?.building} , {startInfo?.location?.address?.locality} ,  {startInfo?.location?.address?.city} , {startInfo?.location?.address?.country} , {startInfo?.location?.address?.state} - {startInfo?.location?.address?.area_code}</span></div>
                            <div><span className="text-gray-500 text-sm">Contact:</span><span className="text-gray-600 text-sm px-2">{startInfo?.contact?.phone}</span></div>
                        </div>}
                    </div>
                    <div className="px-5 w-full mt-10">
                        <div className="mb-2">
                            <h3 className="font-bold text-gray-600 text-xl">Delivery</h3>
                        </div>
                        {endInfo && <div className="mb-2 text-gray-400">
                            <div><span className="text-gray-500 text-sm">Code:</span><span className="text-gray-600 text-sm px-2">{selectedOrder?.DeliveryCode}</span></div>
                            <div><span className="text-gray-500 text-sm">Name</span><span className="text-gray-600 text-sm px-2">{endInfo?.location?.address?.name}</span></div>
                            <div><span className="text-gray-500 text-sm break-words">Address:</span><span className="text-gray-600 text-sm px-2">{endInfo?.location?.address?.building} , {endInfo?.location?.address?.locality} ,  {endInfo?.location?.address?.city} , {endInfo?.location?.address?.country} , {endInfo?.location?.address?.state} - {endInfo?.location?.address?.area_code}</span></div>
                            <div><span className="text-gray-500 text-sm">Contact:</span><span className="text-gray-600 text-sm px-2">{endInfo?.contact?.phone}</span></div>
                        </div>}
                    </div>

                </div>
            </div>




        </>
    )
}